/** Tipi della libreria schede e calcolo del mix dalle quote. */

import { FAMIGLIE_ATTRIBUTO, type FamigliaAttributo, type TipoScheda } from '@calcio/shared';

export interface AttributoPerMix {
  id: string;
  nome: string;
  famiglia: FamigliaAttributo;
  attivo: boolean;
}

/** Il mix dalle quote scritte: solo quelle intere fra 1 e 100. */
export function mixDaQuote(attributi: readonly AttributoPerMix[], quote: Record<string, string>) {
  const mix = attributi
    .map((a) => ({ attributoId: a.id, quota: Number(quote[a.id]) }))
    .filter((v) => Number.isInteger(v.quota) && v.quota >= 1 && v.quota <= 100);
  return { mix, totale: mix.reduce((s, v) => s + v.quota, 0) };
}

export interface VoceMixLetta {
  attributoId: string;
  nome: string;
  famiglia: FamigliaAttributo;
  quota: number;
}

export interface SchedaInElenco {
  id: string;
  nome: string;
  rpeRiferimento: number;
  minutiRiferimento: number;
  tipo: TipoScheda;
  attiva: boolean;
  schedaBaseId: string | null;
  nVarianti: number;
  /** Il mix sommato per famiglia: solo le famiglie presenti, a somma 100. */
  famiglie: Partial<Record<FamigliaAttributo, number>>;
}

export interface VarianteInElenco {
  id: string;
  nome: string;
  rpeRiferimento: number;
  minutiRiferimento: number;
  tipo: TipoScheda;
  attiva: boolean;
  famiglie: SchedaInElenco['famiglie'];
}

export interface SchedaDettaglio extends Omit<SchedaInElenco, 'nVarianti' | 'famiglie'> {
  /** Il nome della base, per una variante. */
  nomeBase: string | null;
  mix: VoceMixLetta[];
  varianti: VarianteInElenco[];
}

/** La famiglia con la quota più alta del mix; a pari quota, la prima del catalogo. */
export function famigliaPrevalente(famiglie: SchedaInElenco['famiglie']): FamigliaAttributo | null {
  let migliore: FamigliaAttributo | null = null;
  for (const f of FAMIGLIE_ATTRIBUTO) {
    if ((famiglie[f] ?? 0) > (migliore ? (famiglie[migliore] ?? 0) : 0)) migliore = f;
  }
  return migliore;
}
